import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components/native';
import Key from './key';
import Colors from '../colors';
import Spacer from '../spacer';
import Icon from '../icon';
const Container = styled.View`
  width: 100%;
  max-width: 232px;
`;
const Row = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;
export default function PinKeypad(_ref) {
  let {
    onChangeText
  } = _ref;

  const addChar = char => onChangeText(value => `${value}${char}`);

  const removeChar = () => onChangeText(value => value.slice(0, -1));

  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(1)
  }, "1"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(2)
  }, "2"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(3)
  }, "3")), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(4)
  }, "4"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(5)
  }, "5"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(6)
  }, "6")), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(7)
  }, "7"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(8)
  }, "8"), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(9)
  }, "9")), /*#__PURE__*/React.createElement(Spacer, {
    size: "f16",
    height: true
  }), /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Key, {
    disabled: true
  }), /*#__PURE__*/React.createElement(Key, {
    onPress: () => addChar(0)
  }, "0"), /*#__PURE__*/React.createElement(Key, {
    onPress: removeChar
  }, /*#__PURE__*/React.createElement(Icon.MaterialIcons, {
    size: 34,
    name: "backspace",
    color: Colors.gray100
  }))));
}
PinKeypad.defaultProps = {
  onChangeText: () => null
};
PinKeypad.propTypes = {
  onChangeText: PropTypes.func
};
//# sourceMappingURL=index.js.map